import { formatDateReadable } from '@nemuru-eng/js-api-client';
import { Controller, FieldPath, FieldValues, useFormContext } from 'react-hook-form';

import { useFieldWrapper } from '@/components/shared/components/NewContextForms/FieldWrapperContext';
import {
  CustomDateField,
  CustomDateFieldProps,
} from '@/components/shared/components/NewContextForms/shared/CustomDateField';
import { ReadOnlyDataRow } from '@/components/shared/components/NewContextForms/shared/ReadOnlyDataRow';
import { FieldVariant } from '@/components/shared/components/NewContextForms/types/FieldVariant';

export interface DateFormFieldProps<TFieldValues extends FieldValues> extends CustomDateFieldProps<TFieldValues> {
  name: FieldPath<TFieldValues>;
  dummyField?: boolean;
}

const isValidDateValue = (value: unknown): value is Date =>
  value instanceof Date && !Number.isNaN(value.getTime());

export function DateFormField<T extends FieldValues>({ name, dummyField = false, ...props }: DateFormFieldProps<T>) {
  const formControl = useFormContext()?.control;
  const wrapField = useFieldWrapper();

  props.value = isValidDateValue(props.value) ? formatDateReadable(props.value) : '-';

  if (!formControl || dummyField)
    return props.fieldVariant === FieldVariant.form ? (
      <CustomDateField disabled={true} {...props} />
    ) : (
      <ReadOnlyDataRow {...props} />
    );

  return wrapField(
    name,
    <Controller
      name={name}
      control={formControl}
      render={({ field, fieldState: { error } }) => (
        <CustomDateField field={field} error={error} fieldVariant={FieldVariant.form} {...props} />
      )}
    />,
  );
}
